import { NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { EnvironmentService } from 'src/app/service/environment.service';

@Component({
  selector: 'app-shop-by',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    NgOptimizedImage,
    NgClass,
    StoryblokLinkDirective,
    StoryblokDirective,
    StoryblokRichTextDirective,
  ],
  templateUrl: './shop-by.component.html',
  styleUrl: './shop-by.component.scss',
})
export class ShopByComponent implements OnInit {
  @Input() title: any;
  @Input() slides: any;
  @Input() background: any;
  @Input() component!: string;

  @Input() _editable: any;
  @Input() _uid!: string;
  components: any;
  _selected!: any;
  constructor(
    private environmentService: EnvironmentService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this._selected = this.slides[0];
    for (let entry of this.slides) {
      if (entry.content?.content.find((x: any) => x.content?.length > 0)) {
        entry._more = true;
      }
    }
  }

  navigate(link: any) {
    const storyblokLink = new StoryblokLinkDirective(this.router);
    storyblokLink.storyblokLink = link;
    storyblokLink.click(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
  }

  onSlideEnter(slide: any, $event: Event) {
    if (this.environmentService.isBrowser()) {
      const window = this.environmentService.getWindow();
      if (window && window?.innerWidth < 768) {
        const navi = new StoryblokLinkDirective(this.router);
        navi.storyblokLink = slide.link;
        navi.click($event);
        return;
      }
      this._selected = slide;
    }
  }
}
